import styled from 'styled-components'

export const StyledMyPageSalesEnquiryModal = styled.div``
